import { parseISO } from "date-fns";
import { MDBAlert, MDBBtn, MDBDatatable, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalContent, MDBIcon, MDBInput, MDBModal, MDBModalFooter, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane, MDBTooltip, MDBToast } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { browserName, browserVersion } from "react-device-detect";

import { useLocation, useNavigate } from "react-router";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import Loader from "../components/Loader";
import Popup from "../components/Popup";
import TransactionDetails from "../components/TransactionDetails";
import ExcelExportButton from "../components/exportToExcel.js";
import { getTransaction, updateTransaction, deletePaymentLinkTrans, deleteTransactions, getAllPaymentTransactions, getStaffInfo, getGBussinessInfo, getGymAddonsList, getPlans, getTokenCount, getTransactionById, getRefundedTransactions, getTransactions, logEvent, sendPaymentLink, importingTransactions, getPricingPlansById, getGSTAddress, numberSignUp, authorzationOtp } from "../services/apiServices";
import calImg from "./../components/images/calendar.svg";
import AddUsers from "./AddUsers";
import PageError from "./PageError";
import ExcelJS from 'exceljs';
import ImportExcelModal from "../components/ImportExcelModal"
import { formatDate, formatDateTimeWithTZ } from '../utils/DateFormat';
import { BasePlanName } from "../utils/BasePlanName";
import ClassTransactions from "./classTransactionsIn";
import { useAnalytics } from "../hooks/useAnalytics";
import { useAccess } from "../context/AccessContext";


const Transctions = () => {
  const { trackButtonClick } = useAnalytics();
  const [plansInfo, setplansInfo] = useState(JSON.parse(localStorage.getItem("planInfo")));
  useEffect(() => {
    setplansInfo(JSON.parse(localStorage.getItem("planInfo")));
  }, [localStorage.getItem("planInfo")]);

  const location = useLocation();
  const navigate = useNavigate();
  const [plans, setPlans] = useState("");
  const [addons, setAddons] = useState([]);
  const [apiError, setApiError] = useState(false);
  const [mfilter, setMfilter] = useState({
    inputText: "",
    // planNme: "",
    tidName: "",
    contNme: "",
    startDate: "",
    endDate: "",
  });
  const [Alerttxt, setAlerttxt] = useState("");
  const [PaymentLinkTrans, setPaymentLinkTrans] = useState([])
  const [filterr, setFilterr] = useState(false);
  const [staff, setStaff] = useState([]);
  const [alertText, setalertText] = useState("");
  const [Error2, setError2] = useState("");
  const [importedData, setImportedData] = useState([]);
  const [importError, setImportError] = useState("");
  const [token, setToken] = useState(null)
  const today = new Date();
  const currentTime = new Date();
  const startOfToday = new Date(currentTime);
  startOfToday.setHours(0, 0, 0, 0);

  // Set end of today
  const endOfToday = new Date(currentTime);
  endOfToday.setHours(23, 59, 59, 999);

  const yesterday = new Date(currentTime);
  yesterday.setDate(currentTime.getDate() - 1);
  const startOfYesterday = new Date(yesterday);
  startOfYesterday.setHours(0, 0, 0, 0);

  const endOfYesterday = new Date(yesterday);
  endOfYesterday.setHours(23, 59, 59, 999);

  const startOfWeek = new Date(currentTime);
  startOfWeek.setDate(currentTime.getDate() - currentTime.getDay());
  startOfWeek.setHours(12, 0, 0, 0);
  const endOfWeek = new Date(currentTime);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  endOfWeek.setHours(12, 0, 0, 0);

  const startOfMonth = new Date(currentTime);
  startOfMonth.setDate(1);
  startOfMonth.setHours(0, 0, 0, 0);

  const endOfMonth = new Date(currentTime);
  endOfMonth.setMonth(currentTime.getMonth() + 1, 0);
  endOfMonth.setHours(23, 59, 59, 999);

  const startOfYear = new Date(currentTime);
  startOfYear.setMonth(0, 1);
  startOfYear.setHours(0, 0, 0, 0);

  const endOfYear = new Date(currentTime);
  endOfYear.setMonth(11, 31);
  endOfYear.setHours(23, 59, 59, 999);

  today.setHours(23, 59, 0, 0);
  const [dateRange, setDateRange] = useState([startOfMonth, today]);
  const [filteredPaymentLinks, setFilteredPaymentLinks] = useState([]);

  const [startDate, endDate] = dateRange;
  const [paymentLinkFilterss, setPaymentLinkFilterss] = useState(false)
  const [loading, setLoading] = useState(true);
  const [userData, setData] = useState([]);
  console.log("userData", userData)
  const [isOpen, setIsOpen] = useState(false);
  const [deleteTrans, setDeleteTrans] = useState(null);
  const [openAUser, setOpenAUser] = useState(false);
  const [tId, setTId] = useState(null);
  const [transid, settransid] = useState("")
  const [Rid, setRid] = useState(null);
  const [basicActive, setBasicActive] = useState("tab1");
  const [totalCount, setTotalcount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [Date11, setDate11] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [Date22, setDate22] = useState(new Date());
  const [valuee, setValuee] = useState(-1);
  const [totalPages, setTotalPages] = useState(1);
  const [userRData, setuserRData] = useState([])
  const [applyFilterClicked, setApplyFilterClicked] = useState(false);
  const [DayFilter, setDayFilter] = useState("4");
  const [customdate, setcustomdate] = useState(DayFilter === "6");
  const [totalTranactions, setTotalTransaction] = useState(0)
  const [totalTranactionsCount, setTotalTractionCount] = useState(0)
  const [classtransAmount, setClasstransAmount] = useState(0)
  const [paymentLinkFilter, setpaymentLinkFilter] = useState(2);
  const [paymentLink, setPaymentLink] = useState(null);
  const [number, setNumber] = useState("");
  const [importPopUp, setImportPopUp] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [membersList, setMembersList] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [parentName, setParentName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [basicModal, setBasicModal] = useState(null);
  const [openAddMember, setOpenAddMember] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [curIndex, setCurIndex] = useState(0);
  const [gstobj, setGstobj] = useState({
    gstin: "",
    address: "",
  })

  const handleclasstransactioninfo = (data) => {
    setClasstransAmount(data)
  }

  useEffect(() => {
    async function fetchData(id, token) {
      if (localStorage.getItem("loggedUserInfo")) {
        const response = await getTransaction(id, JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, token);
        if (!response || response == "false") {

          return;
        }
        const record = await response.json();
        if (!record || record.length === 0) {

          navigate("/");
          return;
        }


        console.log(record);
        if (record && record.length > 0) {
          console.log(record);
          const allMembers = record.flatMap(item => item.member || []);
          const uniqueMembersMap = new Map();

          allMembers.forEach(member => {
            const key = member._id || member.number || member.email;
            if (key && !uniqueMembersMap.has(key)) {
              uniqueMembersMap.set(key, member);
            }
          });
          const uniqueMembers = Array.from(uniqueMembersMap.values());
          setMembersList(uniqueMembers);
        }


      }
    }
    if (token != null) {
      fetchData(tId, token);
    }


  }, [isOpen, tId]);


  const toggleModal = () => {
    setImportPopUp(true);

  }

  const popUpClose = () => {
    setErrorMessage("");
    setImportPopUp(false);
  }
  const handleSampleDownload = () => {
    const sampleData = [
      {
        members: {
          fname: "Kiran",
          lname: "J",
          number: "9876543210",
        },
        isplan: "Weekly",
        payment: {
          mode: "Cash",
          paid: 4000,
        },
        transid: "",
        createdAt: "YYYY/MM/DD",
        startedAt: "YYYY/MM/DD",
      },
      {
        members: {
          fname: "Sushma",
          lname: "P",
          number: "9748596123",
        },
        isplan: "Day",
        payment: {
          mode: "Card",
          paid: 500,
        },
        transid: "T2501281012113879634749",
        createdAt: "YYYY/MM/DD",
        startedAt: "YYYY/MM/DD",
      },
    ];

    // Create a workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sample Data");

    // Define columns
    worksheet.columns = [
      { header: "First Name", key: "fname", width: 20 },
      { header: "Last Name", key: "lname", width: 20 },
      { header: "Phone Number", key: "number", width: 20 },
      { header: "Plan/ Addon", key: "isplan", width: 15 },
      { header: "Payment Mode", key: "mode", width: 10 },
      { header: "Paid Amount", key: "paid", width: 15 },
      { header: "Transaction ID", key: "transid", width: 25 },
      { header: "Transaction Created Date", key: "createdAt", width: 15 },
      { header: "Started Date", key: "startedAt", width: 25 }

    ];
    sampleData.forEach((data) => {
      worksheet.addRow({
        fname: data.members.fname,
        lname: data.members.lname,
        number: data.members.number,
        isplan: data.isplan,
        mode: data.payment.mode,
        paid: data.payment.paid,
        transid: data.transid,
        createdAt: data.createdAt,
        startedAt: data.startedAt,
      });
    });


    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Transaction_Data.xlsx";
      link.click();
    });
  };

  const importTransactionData = async (file) => {

    if (!file) {
      alert("No file selected!");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const reader = new FileReader();

    reader.onload = async () => {
      const buffer = reader.result;
      await workbook.xlsx.load(buffer);
      const worksheet = workbook.getWorksheet(1);

      const importedData = [];
      const errors = [];


      const headers = {};
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        if (cell.value) {
          headers[cell.value.toString().trim()] = colNumber;
        }
      });


      const getCellValue = (row, columnName) => {
        const colNumber = headers[columnName];
        const cellValue = colNumber ? row.getCell(colNumber).value : "";

        if (typeof cellValue === "object" && cellValue !== null) {
          if (cellValue.text) return cellValue.text.toString(); // for RichText
          if (cellValue.result) return cellValue.result.toString(); // for formula result
          return cellValue.toString(); // fallback
        }

        return cellValue?.toString?.() || "";
      };


      const isValidPhoneNumber = (num) => /^\d{10}$/.test(num);
      const isValidNumber = (val) => !isNaN(val) && val >= 0;
      const isValidTaxCheck = (val) => ["Included", "Excluded"].includes(val);
      // const isValidGST = (val) => /^\d+%$/.test(val);
      const isValidPaymentMode = (val) =>
        ["cash", "card", "upi", "wallet", "coupon", "multiple"].includes(val?.toString().trim().toLowerCase());

      const capitalizeFirstLetter = (str) => {
        if (!str) return "";
        str = str.toString().trim().toLowerCase();
        return str.charAt(0).toUpperCase() + str.slice(1);
      };
      const isValidDate = (dateStr) => {
        const date = new Date(dateStr);
        return date instanceof Date && !isNaN(date.getTime());
      };


      const isValidGST = (val) => {
        if (!val) return false;
        const cleanedVal = val.toString().trim();
        return /^\d+(\.\d+)?%?$/.test(cleanedVal);
      };


      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1 && row.hasValues) {
          const fname = capitalizeFirstLetter(getCellValue(row, "First Name"));
          const lname = capitalizeFirstLetter(getCellValue(row, "Last Name"));
          const number = getCellValue(row, "Phone Number");
          const isplan = getCellValue(row, "Plan/ Addon").toString().trim();
          // const isplan = getCellValue(row, "Plan")
          //   .split(',')
          //   .map(p => capitalizeFirstLetter(p.trim()))
          //   .join(', ');
          // const itemprice = parseFloat(getCellValue(row, "Price"));
          const mode = capitalizeFirstLetter(getCellValue(row, "Payment Mode"));
          const paid = parseFloat(getCellValue(row, "Paid Amount"));
          // const gst = getCellValue(row, "GST").toString().trim();
          // const taxcheck = capitalizeFirstLetter(getCellValue(row, "Tax Check"));
          // const totalamount = parseFloat(getCellValue(row, "Total Amount"));
          const transid = capitalizeFirstLetter(getCellValue(row, "Transaction ID"));
          const createdAt = getCellValue(row, "Transaction Created Date").trim();
          const startdate = getCellValue(row, "Started Date").trim()

          const rowErrors = [];

          if (!fname) rowErrors.push("First Name is required.");
          if (!lname) rowErrors.push("Last Name is required.");
          if (!isValidPhoneNumber(number)) rowErrors.push("Phone Number must be 10 digits.");
          if (!isplan || isplan.length === 0) {
            rowErrors.push("Plan/Addon is required.");
          }
          // if (!isValidNumber(itemprice)) rowErrors.push("Price must be a valid number.");
          if (!isValidPaymentMode(mode)) rowErrors.push("Invalid Payment Mode. Allowed: Cash, Card, UPI, Wallet, Coupon, Multiple");
          if (!isValidNumber(paid)) rowErrors.push("Paid Amount must be a valid number.");
          // if (!isValidGST(gst)) {
          //   rowErrors.push("GST must be in valid format (e.g., 18%, 18, 18.5%, 18.5).");
          // }
          // if (!isValidTaxCheck(taxcheck)) rowErrors.push('Tax Check must be "Included" or "Excluded".');
          // if (!isValidNumber(totalamount)) rowErrors.push("Total Amount must be a valid number.");
          if (transid && !/^[a-zA-Z0-9]+$/.test(transid)) rowErrors.push("Transaction ID must be alphanumeric.");
          // if (!itemprice) rowErrors.push("Price is required.");
          // else if (!isValidNumber(itemprice)) rowErrors.push("Price must be a valid number.");

          if (!paid) rowErrors?.push("Paid Amount is required.");
          else if (!isValidNumber(paid)) rowErrors.push("Paid Amount must be a valid number.");

          // if (!totalamount) rowErrors.push("Total Amount is required.");
          // else if (!isValidNumber(totalamount)) rowErrors.push("Total Amount must be a valid number.");
          if (!createdAt) {
            rowErrors.push("Created Date is required.");
          } else if (!isValidDate(createdAt)) {
            rowErrors.push("Created Date must be in valid format (YYYY/MM/DD).");
          }

          if (!startdate) {
            rowErrors.push("Start Date is required.");
          } else if (!isValidDate(startdate)) {
            rowErrors.push("Start Date must be in valid format (YYYY/MM/DD).");
          }


          const createdAtDate = new Date(createdAt); // Parse the existing date
          const now = new Date(); // Get current date and time
          new Date(createdAtDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds()));
          const startedAtDate = new Date(startdate); // Parse the existing date
          new Date(startedAtDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds()));

          console.log(startedAtDate)
          console.log(createdAtDate)

          if (rowErrors.length > 0) {
            errors.push({
              row: rowNumber,
              issues: rowErrors,
            });
          } else {
            importedData.push({
              fname,
              lname,
              number,
              isplan,
              mode,
              paid,
              transid,
              createdAtDate,
              startedAtDate
            });
          }
        }
      });

      if (errors.length > 0) {
        console.error("Import Errors:", errors);
        setErrorMessage(errors.map(e => `Row ${e.row}: ${e.issues.join(", ")}`).join("\n"));
        setTimeout(() => {
          setImportPopUp(false);
          setErrorMessage("");
        }, 20000);
        return;
      }

      console.log("importedData", importedData)
      // setImportedData(importedData);

      if (importedData.length === 0) {
        setImportError("The file is empty or does not contain valid Transactions data.");
        setImportPopUp(false);
        return;
      } else {
        setImportError("");
      }


      try {
        const gymId = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
        const updates = {
          id: JSON.parse(localStorage.getItem("loggedUserInfo"))._id,
          data: importedData,
          limit: (plansInfo != null && plansInfo?.limitation) ? plansInfo?.limitation?.transactions : 100,
          activelimit: (plansInfo != null && plansInfo?.limitation) ? plansInfo?.limitation?.activemembers : 100,
        }
        const response = await importingTransactions(gymId, updates);
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        }
        else {
          const result = await response.json();
          console.log(result);
          console.log("Backend Response:", result);
          if (result?.error) {
            setError2(result.error + "Please upgrade your plan for higher capacity.");
            return;
          }
          if (result.message == "Success.") {
            setalertText("Transaction(s) Imported successfully!");
            setImportPopUp(false);
            await trackButtonClick("Transactions", "Transaction_Import", "staff", {});

            getPricingPlansBYGymid();
          }
          else {
            setError2("Failed to Import Transaction(s)");
            setErrorMessage(result.message);
          }


        }


      } catch (error) {
        console.error("Import Error:", error.message);
        setErrorMessage(error.message);
      }
    };

    reader.readAsArrayBuffer(file);
  };
  const getPricingPlansBYGymid = async () => {
    const response = await getPricingPlansById(JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid);
    if (!response || response === "false") {
      return
    }
    const recinfo = await response.json();
    if (recinfo && recinfo.feature) {
      setplansInfo(recinfo);
      localStorage.setItem("planInfo", JSON.stringify(recinfo));
    }
  }
  useEffect(() => {
    if (basicModal) {

      if (parentName) {

        const matchingMember = membersList && membersList.length > 0 ? membersList.find(member => {
          const fullName = `${member.fname || ''} ${member.lname || ''}`.trim();
          return fullName === parentName;
        }) : {};


        if (matchingMember) {
          setSelectedMemberId(matchingMember._id);
        }
      }
    }
  }, [basicModal, parentName, membersList]);


  const handleChange = (e) => {
    const name = e.target.value;
    setParentName(name);
  }


  const handleChangeMobile = (e) => {
    const mobile = e.target.value;
    setMobile(mobile);
  }

  const handleChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);

  }

  const [gstError, setGSTError] = useState("")
  const [gstverify, setGstverify] = useState(false)
  useEffect(() => {
    const fecthGSTAddress = async () => {
      const gstin = gstobj.gstin.trim();

      // GSTIN validation regex
      const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

      if (!gstinRegex.test(gstin)) {
        console.log("Invalid GSTIN format");
        return;
      }
      const response = await getGSTAddress(gstin)
      if (!response) {
        return;
      }
      if (response === "false") {
        return
      }

      const record = await response.json();

      if (!record || record.error) {
        setGSTError("Invalid GST Number");
        setGstobj({
          gstin: "",
          address: ""
        })
        return;
      }
      setGSTError("");
      console.log(record, 'record,recordrecordrecordrecord');
      handleGstin({ address: record?.name + ", " + record?.businessAddress })
      setGstverify(false)
    }
    if (gstobj.gstin != "") {
      fecthGSTAddress()
    }

  }, [gstverify])

  const handleGstin = (value) => {
    const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;


    setGstobj((prev) => {
      return { ...prev, ...value };
    });
    if (!gstinRegex.test(value.gstin)) {
      console.log("Invalid GSTIN format");
      return;
    } else {
      setGstverify(true)
    }

  }


  async function onSubmitingGurdian(obj) {
    if (!obj) return;

    let id = obj.tId;
    const selectedMember = membersList.find(member => member._id === selectedMemberId);
    const updates = {
      transId: id,
      parentName: selectedMember ? `${selectedMember.fname} ${selectedMember.lname}` : parentName,
      parentEmail: selectedMember?.email || email,
      parentphone: selectedMember?.number || mobile,
      parentName,
      gstin: gstobj.gstin,
      address: gstobj.address
    };

    setBasicModal(null);


    console.log(updates);
    let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";

    const response = await updateTransaction(gymid, updates);

    console.log(response);
  }


  const basicModalClose = () => {
    setBasicModal(null);
  }




  const onHandleBillingDetails = async (id) => {
    const res = await getTransactionById(id);
    if (!res || res === "false") return;
    const updatedUser = await res.json();
    console.log("User being loaded into modal:", updatedUser);

    if (typeof updatedUser?.parentname === "object" && updatedUser.parentname?.name) {
      setParentName(updatedUser.parentname.name || "");
      setMobile(updatedUser.parentname.mobile || "");
      setEmail(updatedUser.parentname.email || "");
      setGstobj({
        gstin: updatedUser?.parentname?.gstin ? updatedUser?.parentname?.gstin : "",
        address: updatedUser?.parentname?.address ? updatedUser?.parentname?.address : "",
      })
      const matchingMember = membersList.find(member => {
        const fullName = `${member.fname || ''} ${member.lname || ''}`.trim();
        return fullName === updatedUser.parentname.name;
      });

      setSelectedMemberId(matchingMember?._id || null);
    } else {
      setParentName("");
      setMobile("");
      setEmail("");
      setSelectedMemberId(null);
    }

    // open modal last (to force rerender)
    setBasicModal(updatedUser);
  };
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };
  // console.log(location, '8888888888888888');


  useEffect(() => {
    setcustomdate(DayFilter === "6" ? true : false);
  }, [DayFilter]);

  // console.log(endDate);

  const [additionsPayment, setAdditionsPayment] = useState([])
  useEffect(() => {
    async function fetchBusData() {
      if (localStorage.getItem("loggedUserInfo")) {
        const response = await getGBussinessInfo(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        } else {
          const record = await response.json();
          if (!record) {
            return;
          }
          console.log(record, '66666666666666666666');
          // setDpaymethods(record.dpaymethods);
          let temOpts = [];
          record.userpaymethods.forEach((opt) => {
            if (opt.check) {
              temOpts.push(opt._id);
            }
          });

          setAdditionsPayment(record.userpaymethods ? record.userpaymethods : [])
          // setUserpaymethods(record.userpaymethods);
        }

      }
    }
    fetchBusData();
  }, []);


  const [notp, setNotp] = useState("");
  const [centredModal, setCentredModal] = useState(false)
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const otpRefs = useRef([]);
  const [error, setError] = useState("");
  const [resendTimer, setResendTimer] = useState(30);
  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");

    if (value) {
      const newOtp = [...otpDigits];
      newOtp[index] = value;
      setOtpDigits(newOtp);
      if (index < otpDigits.length - 1) {
        otpRefs.current[index + 1]?.focus();
      }
    }
  };
  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otpDigits];
      if (otpDigits[index]) {
        // Clear current box
        newOtp[index] = "";
        setOtpDigits(newOtp);
      } else if (index > 0) {
        // Move back and clear
        otpRefs.current[index - 1]?.focus();
        newOtp[index - 1] = "";
        setOtpDigits(newOtp);
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      otpRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < otpDigits.length - 1) {
      otpRefs.current[index + 1]?.focus();
    }
  };
  useEffect(() => {
    if (resendTimer === 0) return;
    const timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [resendTimer]);


  const otpfield = async (e) => {
    // e.preventDefault();
    const response = await authorzationOtp({ phone: JSON.parse(localStorage.getItem("loggedUserInfo")).number, value: !localStorage.getItem("loggedUserInfo") });

    let resData = await response.json();
    console.log(resData);
    if (resData.status != 200) {
      // setError(resData.status === 400 ? "Please try again." : "Number already exits in the system!")
    } else {
      // setError("OTP Sent Successfully");
      setCentredModal(true);
      setResendTimer(30);
      setNotp(resData.otp);
      setOtpDigits(Array(6).fill(""));
      otpRefs.current.forEach((input) => { if (input) input.value = ""; });
      setTimeout(() => { otpRefs.current[0]?.focus(); }, 100);
      setTimeout(() => { setNotp("") }, 300000);
    }
  }

  const [deleteDisable, setDeleteDisable] = useState(false)
  async function transactionDelete(e, data) {
    // e.preventDefault();
    setDeleteDisable(true)
    let id = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";

    await deleteTransactions(id, { data: data });



    let ip = localStorage.getItem("ipaddress");
    let browserinfo = browserName + "-" + browserVersion + ".0.0";
    let flag = `Transaction Deleted Successfull (${data[0].tId})`;
    let Eventtype = "Transaction";
    let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
    let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
    await trackButtonClick("Transactions", "Delete_Transaction", "staff", {});

    logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
    setData(prevState => {
      const updatedValue = prevState.filter(obj => obj.token !== data[0].token);
      return updatedValue;
    });
    setDeleteDisable(false)
    setDeleteTrans(null);
    await fetchData();
    getPricingPlansBYGymid();

    logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);

  }

  const handleVerifyOTP = (e) => {
    const enteredOTP = otpDigits.join("");
    if (notp == "") {
      setError("Your OTP has expired. Please request a new one to continue.");
    } else if (enteredOTP !== notp) {
      setError("Invalid OTP.Please try again.");
    }
    else {
      setError("OTP verified Successfully. ");
      setCentredModal(false);
      transactionDelete(e, deleteTrans)
      // updateBusinessForm({ isnumberverified: true });
    }
  };

  function getToken() {
    try {
      const tokenString = localStorage.getItem("transactionId");
      return tokenString;
    }
    catch (e) {
      console.log("error :::::: " + e);
      return;
    }
  }

  function closeAddPopup() {
    setOpenAUser(false);
    setTId(-1);
  }

  function openAUserPop() {
    setOpenAUser(true);
  }
  let dashboardFilter = false;
  // localStorage.removeItem("transaction_filter")
  const handleResetAndToggle = () => {
    dashboardFilter = true;
    localStorage.removeItem("transaction_filter");
    setCurrentPage(1)
    setMfilter({
      // planNme: "",
      tidName: "",
      contNme: "",
      startDate: "",
      endDate: "",
      // inputText: "",
    });
    setDateRange([startOfMonth, endOfMonth])
    setValuee(-1)
    setDate22(new Date())
    setDate11(new Date())
    // fetchData()
    setDayFilter("4")
    setApplyFilterClicked(true);

    setFilterr((prevFilterr) => !prevFilterr);
    fetchData();
    setpaymentLinkFilter(2);
    setPaymentLinkFilterss(true);
    return;
  };


  async function fetchData(sTxt) {
    if (localStorage.getItem("loggedUserInfo")) {

      console.log(location);
      console.log(window.location.pathname);
      let locfilter = JSON.parse(localStorage.getItem("transaction_filter"));

      let locfilter1 = JSON.parse(localStorage?.getItem("transaction_filter1"))
      console.log(locfilter1);
      if (locfilter1) {
        location.state = {}
        location.state.data = locfilter1?.dashboardFID;
        location.state.fdate = locfilter1?.dashboardFfdate;
        location.state.tdate = locfilter1.dashboardFtdate;
        setDayFilter(locfilter1?.dashboardDayFilter)
      }
      if (location.state && location.state.Dayfilter) {
        setDayFilter((location.state && location.state.Dayfilter ? location.state.Dayfilter : DayFilter))
      } else if (locfilter && locfilter.filters.DayFilter) {
        setDayFilter(locfilter && locfilter.filters.DayFilter !== "" ? locfilter.filters.DayFilter : DayFilter)
      }


      location.filter = {};
      location.filter.tidName = locfilter && locfilter.filters && locfilter.filters.tidName !== "" ? locfilter.filters.tidName : mfilter.tidName
      location.filter.contNme = locfilter && locfilter.filters && locfilter.filters.contNme !== "" ? locfilter.filters.contNme : mfilter.contNme

      location.limitmember = locfilter && locfilter.itemsPerPage ? locfilter.itemsPerPage : itemsPerPage;
      location.currentPage = locfilter && locfilter.currentPage ? locfilter.currentPage : (currentPage > 0 ? currentPage : 1);

      setMfilter({
        tidName: locfilter && locfilter.filters && locfilter.filters.tidName !== "" ? locfilter.filters.tidName : "",
        contNme: locfilter && locfilter.filters && locfilter.filters.contNme !== "" ? locfilter.filters.contNme : "",
        startDate: "",
        endDate: "",
      })


      const dayFilter = locfilter && locfilter.filters.DayFilter !== "" ? locfilter.filters.DayFilter : (location.state && location.state.Dayfilter ? location.state.Dayfilter : DayFilter);
      const sDate = locfilter && locfilter.filters.startDate ? new Date(locfilter.filters.startDate) : (location.state && location.state.fdate ? location.state.fdate : startDate);
      const eDate = locfilter && locfilter.filters.endDate ? new Date(locfilter.filters.endDate) : (location.state && location.state.tdate ? location.state.tdate : endDate)
      console.log(dayFilter, sDate, eDate);


      setFilterr(locfilter && locfilter.filters.filtercheck !== "" ? locfilter.filters.filtercheck : filterr)
      if (locfilter && locfilter.filters.DayFilter) {
        if (locfilter && locfilter.filters.DayFilter !== "7") {
          setDateRange([locfilter && locfilter.filters.startDate ? new Date(locfilter.filters.startDate) : startDate, locfilter && locfilter.filters.endDate ? new Date(locfilter.filters.endDate) : endDate])
        } else {
          setDateRange([startOfMonth, endOfMonth])
        }
      }
      let startOfDate = (dayFilter === "6" ? sDate : (dayFilter === "7" ? "" : (dayFilter === '1' ? startOfToday : (dayFilter === '2' ? startOfYesterday : (dayFilter === "3" ? startOfWeek : (dayFilter === "4" ? startOfMonth : (dayFilter === "5" ? startOfYear : (dayFilter === "6" ? sDate : ""))))))))
      let endOfDate = (dayFilter === "6" ? eDate : (dayFilter === "7" ? "" : (dayFilter === '1' ? endOfToday : (dayFilter === '2' ? endOfYesterday : (dayFilter === "3" ? endOfWeek : (dayFilter === "4" ? endOfMonth : (dayFilter === "5" ? endOfYear : (dayFilter === "6" ? eDate : ""))))))))

      if (dashboardFilter) {
        location.state = null
        location.filter.inputText = ""
        location.filter.inputText = ""
        location.filter.planNme = ""
        location.filter.tidName = ""
        location.filter.contNme = ""
        startOfDate = startOfMonth
        endOfDate = endOfMonth
        setDayFilter("4")
      }
      console.log(startOfDate, endOfDate);
      // if (location.state && location.state.Dayfilter) {
      setDateRange([startOfDate, endOfDate])
      // }


      //the below code is converting in to indian time to us time and sending to backend in the backend also not converting  the date and time
      if ((startOfDate && endOfDate)) {
        const startDatef = new Date(startOfDate)
        startDatef.setHours(0, 0, 0, 0)
        const utcstartDate = startDatef.toISOString();
        location.filter.startDate = utcstartDate;
        let lastoftheday = new Date(endOfDate);
        lastoftheday.setHours(23, 59, 59, 999);
        const utcEndDate = lastoftheday.toISOString();

        location.filter.endDate = utcEndDate;
        console.log(utcstartDate, utcEndDate);

      }

      console.log(location);
      const response = await getTransactions(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
        location
      );

      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
      } else {


        const usersData = await response.json();
        if (!usersData) {

          navigate("/");
          return;
        }

        console.log(usersData);

        // setTotalMemberCount(usersData.uniqueMemberCount)
        setTotalTractionCount(usersData.uniqetotalTransactionsCount ? usersData.uniqetotalTransactionsCount : 0)
        setData(usersData.transctions);
        setTotalTransaction(usersData.totalPayment ? parseFloat((usersData.totalPayment).toFixed(2)) : 0)
        setTotalPages(usersData.transctions && usersData.transctions.length > 0 ? usersData.totalPages : 1)
        setTotalcount(usersData.totalTransactionsCount ? usersData.totalTransactionsCount : 0)
        // }
        if (currentPage > ((usersData.transctions && usersData.transctions.length > 0) ? usersData.totalPages : 1)) {
          setCurrentPage(1)
        }
        setLoading(false)
        setApplyFilterClicked(false)
        setValuee(location && location.state && location.state.data);
        setDate11(location && location.state && location.state.fdate);
        setDate22(location && location.state && location.state.tdate);
        localStorage.removeItem("transaction_filter1");
      }
    }
  }


  const filterpaymentmode = (trans) => {
    let obj = {
      Razorpay: 0,
      Cash: 0,
      Card: 0,
      UPI: 0,
      Wallet: 0,
      Coupon: 0,
    }
    trans.paymenthistory && trans.paymenthistory.length > 0 && trans.paymenthistory.forEach((item) => {
      switch (item.mode) {
        case -3:
          obj.Razorpay += item.paid;
          break;
        case 1:
          obj.Cash += item.paid;
          break;
        case 2:
          obj.Card += item.paid;
          break;
        case 3:
          obj.UPI += item.paid;
          break;
        case 4:
          obj.Wallet += item.paid;
          break;
        case 5:
          obj.Coupon += item.paid;
          break;
        case 6:
          const payInfo = JSON.parse(item.payinfo).info;
          if (payInfo.cash_amt) {
            obj.Cash += parseFloat(payInfo.cash_amt);
          }
          if (payInfo.cc_amt) {
            obj.Card += parseFloat(payInfo.cc_amt);
          }
          if (payInfo.upi_amt) {
            obj.UPI += parseFloat(payInfo.upi_amt);
          }
          if (payInfo.wallet_amt) {
            obj.Wallet += parseFloat(payInfo.wallet_amt);
          }
          break;
        default:
          break;
      }
    });

    // console.log(obj, '888888888888888888');
    return obj
  }

  const downloaddata = async (data) => {
    if (basicActive === "tab1") {
      fetchDataAndExport();
    } else if (basicActive === "tab3") {
      let value = data.rows.map(row =>
        row.map(cell => {
          if (cell.props && cell.props.children) {
            return cell.props.children[0]?.props.children;
          }
          return cell;
        })
      );
      const exportData = {
        columns: data.columns, // Column headers
        rows: value,       // Transformed rows
      };
      ExcelExportButton(exportData, "Activemembership");
    } else {
      await trackButtonClick("Transactions", "Refund_Export", "staff", {});

      ExcelExportButton(data, "Refund_data");
    }

  }
  const fetchDataAndExport = async () => {
    // location.limitmember = totalCount;
    // location.currentPage = 1;
    const exportfilters = location;
    exportfilters.limitmember = totalCount;
    exportfilters.currentPage = 1;
    const response = await getTransactions(
      JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
      exportfilters
    );

    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
      return;
    }

    const transData = await response.json();
    console.log(transData);
    if (!transData) {
      return;
    }


    let tmrow = [];
    let uniqueTIds = new Set();
    const usersData = transData.transctions && transData.transctions.length > 0 ? transData.transctions : [];
    const allTaxTitles = usersData.length > 0 ? usersData.flatMap(user =>
      user.alldata.flatMap(txn =>
        (txn.payment?.taxamounts || [])
          .filter(tax => tax.title)   // skip objects without title
          .map(tax => tax.title)
      )
    ) : [];
    // Step 2: Get unique titles
    const uniqueTaxTitles = [...new Set(allTaxTitles)];

    console.log(uniqueTaxTitles);
    if (usersData.length > 0) {



      usersData.forEach((data1) => {
        const alldata = data1.alldata;
        const groupedMembers = alldata;

        console.log("groupedMembers", groupedMembers)



        const getDisplayName = (member, plans) => {
          if (member.subplan && member.subplan.baseplan) {
            const baseName = BasePlanName(plans, member.subplan.baseplan);
            return baseName ? `${baseName} - ${member.subplan.name}` : member.subplan.name;
          } else if (member.plan && member.plan.name) {
            return member.plan.name;
          } else if (member.addons && member.addons.length > 0) {
            return member.addons[0].name;
          }
          return "";
        };


        alldata.forEach((data) => {
          if (!uniqueTIds.has(data.token) && data.isplan !== "3") {
            const paymentHistory = data.paymenthistory || [];
            let tokenCount = 0;
            groupedMembers.forEach((member, memberIndex) => {
              let rarray = [];
              let token = data.token;
              if (memberIndex > 0) {
                tokenCount++;
                token = token + "-" + tokenCount;
              } else {
                tokenCount = 1;
                token = token + "-" + tokenCount;



              }

              let tPlans = getDisplayName(member, plans);


              // let tPlans = groupedMembers.map((itm) => {
              //   if (itm.subplan && itm.subplan.baseplan) {
              //     // subplan case → baseplan - subplan
              //     const baseName = BasePlanName(plans, itm.subplan.baseplan);
              //     return baseName ? `${baseName} - ${itm.subplan.name}` : itm.subplan.name;
              //   } else if (itm.plan && itm.plan.name) {
              //     // normal plan
              //     return itm.plan.name;
              //   } else if (itm.addons && itm.addons.length > 0) {
              //     // addon case
              //     return itm.addons[0].name;
              //   }
              //   return "";
              // });





              const amount = member.payment.itemprice;

              let excludeTaxAmount = ((member.payment?.taxamounts.length > 0 && member.payment.taxamounts.some((obj) => obj?.TaxCheck === "Included"))
                ? parseFloat((amount) / (1 + ((member.payment.taxamounts && member.payment.taxamounts.length > 0)
                  ? (member.payment.taxamounts.reduce((acc, obj) => acc + (obj.percentage ? (parseFloat(obj.percentage) / 100) : 0), 0))
                  : 0))).toFixed(2)
                : amount);

              let actualamount = excludeTaxAmount - (member.payment.discount ? member.payment.discount.amount : 0);

              let taxamount = actualamount * (((member.payment.taxamounts && member.payment.taxamounts.length > 0)
                ? (member.payment.taxamounts.reduce((acc, obj) => acc + (obj.percentage ? (parseFloat(obj.percentage) / 100) : 0), 0))
                : 0));

              const staffName = staff.length > 0 ? staff.find((item) => item._id === data.staffid) : null;
              const transModeData = filterpaymentmode(data);
              let memberActualTotalAmount = actualamount + taxamount; // Plan's actual total amount including tax
              let transactionActualAmount = member.payment.totalamount; // The recorded transaction amount
              let transactionPaidAmount = member.payment.paid; // Actual paid amount by the member

              // **Calculate the ratio of the paid amount to the actual transaction amount**
              let paidRatio = transactionPaidAmount / transactionActualAmount;

              // **Determine the proportionate amount paid for this specific plan**
              let memberPaidAmount = memberActualTotalAmount * paidRatio;
              let memberDueAmount = memberActualTotalAmount - memberPaidAmount;

              const memberPayments = {
                Cash: transModeData.Cash ? ((transModeData.Cash / transactionPaidAmount) * memberPaidAmount) : 0,
                Card: transModeData.Card ? ((transModeData.Card / transactionPaidAmount) * memberPaidAmount) : 0,
                UPI: transModeData.UPI ? ((transModeData.UPI / transactionPaidAmount) * memberPaidAmount) : 0,
                Wallet: transModeData.Wallet ? ((transModeData.Wallet / transactionPaidAmount) * memberPaidAmount) : 0,
                Coupon: transModeData.Coupon ? ((transModeData.Coupon / transactionPaidAmount) * memberPaidAmount) : 0,
                Razorpay: transModeData.Razorpay ? ((transModeData.Razorpay / transactionPaidAmount) * memberPaidAmount) : 0,
              };
              const additionalPayments = {};
              additionsPayment?.forEach((item, index) => {
                const paymentMode = `PaymentType_${index + 7}`;
                const paymentPercentage = paymentHistory.length > 0
                  ? paymentHistory.filter((mode) => mode.mode == 7 + index).reduce((sum, item) => sum + item.paid, 0)
                  : 0;
                additionalPayments[paymentMode] = (paymentPercentage / transactionPaidAmount) * memberPaidAmount;
              });

              rarray.push(token);
              rarray.push(member.members ? `${member.members.fname} ${member.members.lname}` : "");
              rarray.push(formatDateTimeWithTZ(data.createdAt));
              rarray.push(formatDateTimeWithTZ(data.updatedAt));
              rarray.push(tPlans);
              rarray.push(Math.round(memberActualTotalAmount + (member.payment.discount ? member.payment.discount.amount : 0)));
              rarray.push(Number(member.payment.discount ? member.payment.discount.amount : 0));
              // member.payment.taxamounts.forEach((tax) => {
              //   if (tax.percentage && tax.title) {
              //     const percentage = parseFloat(tax.percentage.replace("%", ""));
              //     const taxAmount = Math.round((memberActualTotalAmount * percentage) / 100);
              //     rarray.push(taxAmount);
              //   }
              // });
              uniqueTaxTitles.forEach((taxTitle) => {
                // Find if this tax exists in member.payment.taxamounts
                const taxObj = member.payment.taxamounts.find(tax => tax.title === taxTitle);

                if (taxObj && taxObj.percentage) {
                  const percentage = parseFloat(taxObj.percentage.replace("%", ""));
                  const taxAmount = Math.round((memberActualTotalAmount * percentage) / 100);
                  rarray.push(taxAmount);
                } else {
                  // Tax not present, push 0
                  rarray.push(0);
                }
              });
              rarray.push(Number(memberDueAmount.toFixed(2)));

              rarray.push(Number(memberPayments.Cash.toFixed(2)));
              rarray.push(Number(memberPayments.Card.toFixed(2)));
              rarray.push(Number(memberPayments.UPI.toFixed(2)));
              rarray.push(Number(memberPayments.Wallet.toFixed(2)));
              rarray.push(Number(memberPayments.Coupon.toFixed(2)));
              rarray.push(Number(memberPayments.Razorpay.toFixed(2)));
              additionsPayment?.forEach((item, index) => {
                const paymentMode = `PaymentType_${index + 7}`;
                rarray.push(Number(additionalPayments[paymentMode]?.toFixed(2) || 0));
              });

              rarray.push(data.payment.ispinelabs ? (data.payment.transid || '—') : '');
              rarray.push(Math.round(memberActualTotalAmount));
              rarray.push(1);
              rarray.push(data?.parentname?.gstin ? data?.parentname?.gstin : "--")
              rarray.push(data?.parentname?.address ? data?.parentname?.address : "--")
              rarray.push(staffName ? (staffName.firstname || staffName.lastname ? `${staffName.firstname} ${staffName.lastname}` : staffName.username) : "self");
              tmrow.push(rarray);
            });
            uniqueTIds.add(data.token);
          }
        });
      });
    }
    console.log(tmrow);
    const column = [
      "OrderId",
      "Member(s)",
      "Created Date",
      "Updated Date",
      "Plan/Addon",
      "Actual Price(Incl.tax)",
      "Discount",
      "Due",
      "Cash",
      "Card",
      "UPI",
      "Wallets",
      "Coupons",
      "Razorpay",
      ...(additionsPayment && additionsPayment.length > 0
        ? additionsPayment.map(item => item.title)
        : []),
      "Pine Labs ID",
      "Total(Incl.tax)",
      "Quantity",
      "GSTIN",
      "Address",
      "Staff"
    ]
    const discountIndex = column.indexOf("Discount");
    if (discountIndex !== -1) {
      column.splice(discountIndex + 1, 0, ...uniqueTaxTitles);
    }
    const updatedBasicData = {
      columns: column,
      rows: tmrow.length > 0 && tmrow,
    };
    console.log(updatedBasicData, '1111111111111111111');

    ExcelExportButton(updatedBasicData, "Transactions_Data");
    await trackButtonClick("Transactions", "Transaction_Export", "staff", {});
  }


  const togglePopup = (event, tId, token, _id, id) => {
    event.preventDefault();
    setTId(tId);
    setToken(token)
    setIsOpen(!isOpen);
    setRid(id);
    settransid(_id)
  };

  const closePopup = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };


  useEffect(() => {

    fetchData();
  }, [currentPage, itemsPerPage, applyFilterClicked, importPopUp]);
  function resendPaymentHandler(e, data) {
    e.preventDefault();
    console.log(data);
    setNumber(data.number);
    setPaymentLink(data);
  }
  async function resendPayment(e, data) {
    e.preventDefault();
    console.log(data);
    let updates = {
      number: number,
      amount: data.amount,
      gymid: data.gymid,
      tid: data.tId,
      membName: data.membername,
      clientUrl: window.location.origin,
      transdetails: data.transdetails,
    };
    console.log(updates);
    deletePaymentLinkTrans(data._id);
    let response = await sendPaymentLink(data.gymid, updates);
    if (response.status === 200) {
      let resObj = await response.json();
      console.log(resObj);
      console.log("----------------------------------------------------")
      console.log("generated payment url::", resObj.genratedpaymentLink);
      console.log("----------------------------------------------------")

      setPaymentLinkTrans(prevState =>
        prevState.map(obj =>
          obj._id === data._id ? { ...obj, status: 0, number: updates.number, _id: resObj.response._id, createdAt: new Date() } : obj
        )
      );
      if (resObj.error) {
        if (resObj.error == "error in generating link") {
          setAlerttxt("Failed to generate payment link. try again");

        } else {
          setAlerttxt("Failed to send SMS of payment link. try again");
        }
      }
      if (resObj.response && resObj.response._id) {
        setAlerttxt("payment link sent");
      }
    }
    setNumber("");
    setPaymentLink(null);
  }
  useEffect(() => {
    if (basicActive === "tab3") {
      fetchPLData();
      filterData();
    }
    if (basicActive === "tab2") {
      fetchRefundsData();
    }
  }, [basicActive])

  async function fetchRefundsData() {
    const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
    if (!gymid) return;
    const res = await getRefundedTransactions(gymid);
    if (!res || res === "false") return;
    const data = await res.json();
    setuserRData(data);
  }

  async function fetchPData() {
    if (localStorage.getItem("loggedUserInfo")) {
      const response = await getPlans(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
      } else {
        const plans = await response.json();

        if (!plans) {
          return;
        }
        setPlans(plans);
      }
      const resp = await getGymAddonsList(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      // if (!resp) {
      //   return;
      // }
      if (resp === "false") {
        setApiError(true)
      } else {
        setAddons(await resp.json());
        setLoading(false)
      }
    }
  }
  useEffect(() => {

    fetchPLData();
    fetchPData();
  }, [basicModal])
  async function fetchPLData() {
    if (JSON.parse(localStorage.getItem("loggedUserInfo"))) {
      const res = await getAllPaymentTransactions(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
      if (!res) {
        return;
      }
      if (res === "false") {
        setApiError(true)
      } else {
        let usersData = await res.json();
        if (usersData.length > 0) {
          usersData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        }
        setPaymentLinkTrans(usersData);
        console.log("PaymentLinkTransactions::: ", usersData);
      }
    }
  }

  useEffect(() => {
    const fetchstaffData = async () => {
      if (localStorage.getItem("loggedUserInfo")) {
        const response = await getStaffInfo(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        } else {
          const usersData = await response.json();
          setStaff(usersData)
        }
      }
    }
    fetchstaffData();
  }, [])
  const filteredobject = {
    filters: {
      tidName: mfilter.tidName,
      contNme: mfilter.contNme,
      startDate: endDate,
      endDate: startDate,
      DayFilter: DayFilter,
      apply: true,
      filtercheck: true
    },
    dashboardDayFilter: DayFilter,
    dashboardFID: valuee,
    dashboardFfdate: Date11,
    dashboardFtdate: Date22,
  }

  function handleClik(data) {
    localStorage.setItem("transaction_filter1", JSON.stringify(filteredobject))
    let selMember = data.members

    selMember.Date11 = Date11;
    selMember.Date22 = Date22;
    selMember.anotherColumn = valuee;
    selMember.filters = {
      inputText: mfilter.inputText,
      planNme: mfilter.planNme,
      tidName: mfilter.tidName,
      contNme: mfilter.contNme,
      startDate: startDate,
      endDate: endDate,
      DayFilter: DayFilter
    }
    selMember.transactiontype = 3;
    selMember.addon = [];
    selMember.address = data.members && data.members.address ? data.members.address : "";
    selMember.age = data.members.age ? data.members.age : "";
    selMember.bId = data.members.bId;
    selMember.bloodgroup = data.members.bloodgroup || "";
    selMember.city = data.members.city ? data.members.city : "";
    selMember.country = data.members.country ? data.members.country : "";
    selMember.createdAt = data.members.createdAt;
    selMember.email = data.members.email ? data.members.email : "";
    selMember.expirydate = data.members.expirydate;
    selMember.fname = data.members && data.members.fname;
    selMember.height = data.members && data.members.height ? data.members.height : null;
    selMember.lname = data.members && data.members.lname;
    selMember.mID = data.members.mID;
    selMember.member = data.members.member ? data.members.member : "";
    selMember.number = data.members.number;
    selMember.others = data.members.others ? data.members.others : "";
    selMember.plan = data.plan || [];
    selMember.planid = data.members.planid;
    selMember.referral = data.members.referral;
    selMember.sex = data.members.sex;
    selMember.startdate = data.members.startdate;
    selMember.updatedAt = data.members.updatedAt;
    selMember.weight = data.members.weight || null;
    selMember.__v = 0;
    selMember._id = data.members._id;
    selMember.return = "transactions"

    console.log(selMember);
    navigate("/mdetails", {
      state: selMember,
    });
  }


  let tmrow = [];
  const usersData = userData
  let uniqueTIds = new Set();
  usersData && usersData.length > 0 && usersData.forEach((data1, ind) => {
    const alldata = data1.alldata

    const groupedMembers = alldata

    // console.log(groupedMembers);
    let rarray = [];
    alldata.forEach((data, index) => {
      // console.log(data,'867777466');
      if (!uniqueTIds.has(data.token) && data.isplan !== "3") {

        let taxamount = 0
        const uniqueItemIdsSet = new Set();
        groupedMembers.filter(item => {
          if (!uniqueItemIdsSet.has(item.itemId)) {
            item.payment.taxamounts && (taxamount += item.payment.taxamounts.reduce((acc, itm) => acc + (itm.amount ? itm.amount : 0), 0));
            uniqueItemIdsSet.add(item.itemId);
            return true;
          }
          return false;
        });



        const memberIdSet = new Set();


        const uniqueTransactions = groupedMembers.filter(transaction => {

          if (!memberIdSet.has(transaction?.members?._id)) {

            memberIdSet.add(transaction?.members?._id);
            return true;
          }

          return false;
        });
        const memberNames = uniqueTransactions.map(item => item.members ? (item.members.fname + " " + item.members.lname) : "");
        // console.log(uniqueTransactions);
        // let tPlans = groupedMembers.map((itm) => (itm.plan && itm.plan.name) ? itm.plan.name : (itm.addons && itm.addons.length > 0 ? itm.addons[0].name : ""));

        let tPlans = groupedMembers.map((itm) => {
          if (itm?.subplan && itm?.subplan?.baseplan) {
            // subplan case → baseplan - subplan
            const baseName = BasePlanName(plans, itm.subplan.baseplan);
            return baseName ? `${baseName} - ${itm.subplan.name}` : itm.subplan.name;
          } else if (itm.plan && itm.plan.name) {
            // normal plan
            return itm.plan.name;
          } else if (itm.addons && itm.addons.length > 0) {
            // addon case
            return itm.addons[0].name;
          }
          return "";
        });





        let tdiscount = groupedMembers.reduce((acc, itm) => acc + ((itm.payment.discount && itm.payment.discount.amount) ? itm.payment.discount.amount : 0), 0)
        const uniquePlanNames = [...new Set(tPlans)];
        // console.log(memberNames);
        const paymentHistory = data.paymenthistory ? data.paymenthistory : [];
        // console.log(paymentHistory, '99999999');
        const transModeData = filterpaymentmode(data)
        const staffName = staff.length > 0 && staff.filter((item) => item?._id === data.staffid)[0]
        // console.log(staffName);
        rarray.push(ind + 1 + ((currentPage - 1) * itemsPerPage))
        rarray.push(
          <button className="button-link link-color" onClick={(event) => togglePopup(event, data.tId, data.token, data._id, data.parentname)}>{data.token ? data.token : data.tId}</button>);

        rarray.push(<MDBTooltip tag='div'
          title={data?.members && memberNames?.join(", ")} >
          <span className="d-flex">
            {uniqueTransactions.length >= 1 &&
              uniqueTransactions.map((item, index) =>
                <div className="link-color " onClick={() => handleClik(item)}> {item.members && item.members.fname + " " + item.members.lname}{uniqueTransactions.length === (index + 1) ? " " : ","}{" "} </div>
              )
              // :
              // <div > {data.members && memberNames.length > 1 ? memberNames.join("") : memberNames.join(",")}</div>
            }</span>
        </MDBTooltip>);
        rarray.push(<span className='trans-date'>{formatDateTimeWithTZ(data.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", })}</span>);
        rarray.push(<span className='trans-date'>{formatDateTimeWithTZ(data.updatedAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", })}</span>);
        rarray.push(data?.parentname?.name || data?.members?.fname + " " + data?.members?.lname);
        rarray.push(<MDBTooltip tag='div'
          title={uniquePlanNames.join(", ")} >
          {uniquePlanNames.join(", ")}
        </MDBTooltip>);
        // rarray.push(uniquePlanNames.join(", "));
        // rarray.push("₹" + ((data.payment.paid).toLocaleString('en-IN')));
        rarray.push("₹" + (Number(data.payment.totalamount) + Number(tdiscount)).toLocaleString('en-IN'));
        rarray.push("₹" + (tdiscount).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 }));
        // rarray.push("₹" + (data.payment.taxamounts ? taxamount : (data.payment.taxamt ? data.payment.taxamt : 0)).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 }));
        rarray.push("₹" + data.payment.balance.toLocaleString('en-IN'));
        rarray.push("₹" + (transModeData.Cash ? transModeData.Cash : 0));
        rarray.push("₹" + (transModeData.Card ? transModeData.Card : 0));
        rarray.push("₹" + (transModeData.UPI ? transModeData.UPI : 0));
        rarray.push("₹" + (transModeData.Wallet ? transModeData.Wallet : 0));
        rarray.push("₹" + (transModeData.Coupon ? transModeData.Coupon : 0));
        rarray.push("₹" + (transModeData.Razorpay ? transModeData.Razorpay : 0));
        {
          additionsPayment &&
            additionsPayment.map(
              (item, index) => {
                rarray.push("₹" + (item.title && paymentHistory.length > 0 ? paymentHistory.filter((mode) => mode.mode == 7 + index).reduce((sum, item) => sum + item.paid, 0) : 0));
              }
            )
        }
        rarray.push(data.payment.ispinelabs ? (data.payment.transid || '—') : '');
        rarray.push("₹" + data.payment.totalamount.toLocaleString('en-IN'));
        rarray.push(groupedMembers.length);
        rarray.push(data?.parentname?.gstin ? data?.parentname?.gstin : "--")
        rarray.push(<MDBTooltip tag='div'
          title={data?.parentname?.address ? data?.parentname?.address : "--"} >
          {data?.parentname?.address ? data?.parentname?.address : "--"}
        </MDBTooltip>)
        rarray.push(staffName ? (staffName.firstname || staffName.lastname ? staffName.firstname + " " + staffName.lastname : staffName.username) : "self")
        rarray.push(<MDBIcon fas icon="trash" onClick={(e) => setDeleteTrans(groupedMembers)} />);
        tmrow.push(rarray);
        uniqueTIds.add(data.token);
      }
    })
  });


  const basicData = {
    columns: [
      "S.no",
      "Order Id",
      "Member(s)",
      "Created Date",
      "Updated Date",
      "Billing Name",
      "Plan/Addon",
      "Actual Price(incl.tax)",
      "Discount",
      // "Tax",
      "Due",
      "Cash",
      "Card",
      "UPI",
      "Wallets",
      "Coupons",
      "Razorpay",
      ...(additionsPayment && additionsPayment.length > 0
        ? additionsPayment.map(item => item.title)
        : []),
      "Pine Labs ID",
      "Total(Incl.tax)",
      // "Contact",

      "Quantity",
      "GSTIN",
      "Address",
      "Staff",
      "Delete",
    ],
    rows: tmrow,
  };

  const CalenderInput = forwardRef(({ value, onClick }, ref) => (
    <>
      <span className="form-control select-input  placeholder-active me-3 shadow-1" onClick={onClick}>
        <p className="d-inline m-0 me-2">
          {value === "" ? "Custom Range" : value}
        </p>
        <img src={calImg} ref={ref} alt="Custom Range" title="Select Custom Range" />
      </span>
    </>
  ));
  const basicDataR1 = userRData


  let tmrowR = [];
  let uniqueTIdsR = new Set();
  basicDataR1.length > 0 && basicDataR1.forEach((data) => {
    // const groupedMembers = usersData.filter(item => (item.tId === data.tId));
    const memberNames = data.members ? (`${data.members.fname} ${data.members.lname}`) : false;



    // const planNames = data.itemid
    //   ? (plans.find(item => item._id === data.itemid)
    //     ? plans.find(item => item._id === data.itemid).name
    //     : (addons.find(item => item._id === data.itemid)
    //       ? addons.find(item => item._id === data.itemid).name
    //       : false))
    //   : false;


    const planNames = data?.itemid
      ? (() => {
        // 1 Check normal plans
        const plan = plans.find(p => p._id === data.itemid);
        if (plan) return plan.name;

        // 2 Check inside subplans
        for (const p of plans) {
          if (p.subplans && p.subplans.length > 0) {
            const subplan = p.subplans.find(sp => sp._id === data.itemid);
            if (subplan) {
              return `${p.name} - ${subplan.name}`; // baseplan - subplan
            }
          }
        }

        // 3Check addons
        const addon = addons.find(a => a._id === data.itemid);
        if (addon) return addon.name;

        return false;
      })()
      : false;




    // const uniquePlanNames = [...new Set(planNames)];
    if (!uniqueTIdsR.has(data.token) && data.refund) {
      const sortedRefund = data.refund.length > 0 && data.refund.slice().sort((a, b) => {
        const createdAtA = new Date(a.date);
        const createdAtB = new Date(b.date);
        return createdAtB - createdAtA;
      });
      sortedRefund && sortedRefund.forEach((obj) => {
        let rarrayr = [];
        const rawOrderId = obj.token ? obj.token : data.tId;
        rarrayr.push(
          <button className="button-link link-color" onClick={(event) => togglePopup(event, data.tId, data.token, data._id
          )}>
            {rawOrderId}
          </button>)
        rarrayr.rawOrderId = rawOrderId;
        rarrayr.push(
          formatDateTimeWithTZ(obj.date).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          })
        );
        rarrayr.push(
          data.isplan === "3"
            ? "Balance Payment"
            : planNames
          // uniquePlanNames.join(", ")
        );
        rarrayr.push(obj.refundamount ? "₹" + obj.refundamount : "");
        rarrayr.push(obj.taxamt ? "₹" + obj.taxamt : "");
        rarrayr.push(obj.reason ? <MDBTooltip tag='div'
          title={obj.reason} >
          {obj.reason}
        </MDBTooltip> : "");
        rarrayr.push(
          data.members
          && data.members.number
          // : "Pay Transaction(" + data.ref_token ? data.ref_token : data.ref_id + ")"
        );

        rarrayr.push(
          data.members
            ? memberNames
            : "Pay Transaction(" + data.ref_id + ")"
        );
        rarrayr.push(data.quantity);
        tmrowR.push(rarrayr);
      })
      uniqueTIdsR.add(data.token);
    }
  });
  tmrowR.sort((a, b) => new Date(b[1]) - new Date(a[1]));
  const basicDataR = {
    columns: [
      'OrderId',
      "Date",
      "Plan/Addon",
      "Amount (Incl.tax)",
      "Tax",
      "Reason",
      "Contact",
      "Member(s)",
      "Quantity",
    ],
    rows: tmrowR,
  };
  const filterData = () => {
    const filtered = PaymentLinkTrans.filter((el) => {
      let isValid = true;

      if (mfilter.tidName) {
        isValid = isValid && el.tId?.toLowerCase().includes(mfilter.tidName.toLowerCase());
      }
      if (mfilter.contNme) {
        isValid = isValid && el.number?.includes(mfilter.contNme);
      }
      if (paymentLinkFilter != 2) {
        isValid = isValid && (el.status == paymentLinkFilter);
      }

      // Handle date filtering
      if (DayFilter && DayFilter !== "7") {
        let dayFilter = DayFilter;
        const createdAtDate = new Date(el.createdAt);
        let startOfDate = (dayFilter === "6" ? startDate : ((dayFilter === '1' ? startOfToday : (dayFilter === '2' ? startOfYesterday : (dayFilter === "3" ? startOfWeek : (dayFilter === "4" ? startOfMonth : (dayFilter === "5" ? startOfYear : "")))))))
        let endOfDate = (dayFilter === "6" ? endDate : ((dayFilter === '1' ? endOfToday : (dayFilter === '2' ? endOfYesterday : (dayFilter === "3" ? endOfWeek : (dayFilter === "4" ? endOfMonth : (dayFilter === "5" ? endOfYear : "")))))))
        const start = new Date(startOfDate);
        const end = new Date(endOfDate);
        end.setHours(23, 59, 59, 999);
        isValid = isValid && createdAtDate >= start && createdAtDate <= end;
      }

      return isValid;
    });

    setFilteredPaymentLinks(filtered);
    setPaymentLinkFilterss(false);
  };

  useEffect(() => {

    filterData();
  }, [paymentLinkFilterss, applyFilterClicked]);
  console.log(filteredPaymentLinks);
  let tmrowP = [];

  filteredPaymentLinks.length > 0 && filteredPaymentLinks.forEach((data, index) => {
    let rarrayr = [];
    rarrayr.push(index + 1);
    // rarrayr.push(data.uniqueid ? data.uniqueid : "--");
    rarrayr.push(data.tId + (data.transdetails[0].isplan === 3 ? "-Due" : ""));
    // rarrayr.push(data.token ? data.token : "--");
    rarrayr.push(
      new Date(data.createdAt).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
      })
    );
    rarrayr.push(data.number);
    rarrayr.push("₹" + data.amount);
    rarrayr.push(data.response && data.response.paymentInstrument ? data.response.paymentInstrument.type : "--");
    rarrayr.push(data.status === 1 ? "Success" : (data.status === 0 ? "Pending" :
      <div className="d-flex align-items-center">
        <div className="me-2">
          Failed
        </div>
        <div className="link-color" onClick={(e) => resendPaymentHandler(e, data)}>Resend</div>
      </div>
    ));
    tmrowP.push(rarrayr);
  })
  const basicDataP = {
    columns: [
      'S.no',
      'Transaction ID',
      "Date",
      "Contact",
      "Amount",
      "Payment Type",
      "Status",
    ],
    rows: tmrowP,
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
    setLoading(true)
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
    setLoading(true)
  };


  let filter = {}

  const handleApplyAndToggle = () => {
    let startOfDate = (DayFilter === "6" ? startDate : (DayFilter === "7" ? "" : (DayFilter === '1' ? startOfToday : (DayFilter === '2' ? startOfYesterday : (DayFilter === "3" ? startOfWeek : (DayFilter === "4" ? startOfMonth : (DayFilter === "5" ? startOfYear : (DayFilter === "6" ? startDate : ""))))))))
    let endOfDate = (DayFilter === "6" ? endDate : (DayFilter === "7" ? "" : (DayFilter === '1' ? endOfToday : (DayFilter === '2' ? endOfYesterday : (DayFilter === "3" ? endOfWeek : (DayFilter === "4" ? endOfMonth : (DayFilter === "5" ? endOfYear : (DayFilter === "6" ? endDate : ""))))))))
    filter.inputText = mfilter.inputText
    filter.planNme = mfilter.planNme
    filter.tidName = mfilter.tidName
    filter.contNme = mfilter.contNme
    filter.startDate = mfilter.startDate

    filter.endDate = mfilter.endDate

    console.log(startOfDate, endOfDate);
    setCurrentPage(1)
    const filteredobject = {
      filters: {

        tidName: mfilter.tidName,
        contNme: mfilter.contNme,
        startDate: new Date(startOfDate),
        endDate: new Date(endOfDate),
        DayFilter: DayFilter,
        apply: true,
        filtercheck: true
      },
      dashboardDayFilter: DayFilter,
      dashboardFID: valuee,
      dashboardFfdate: Date11,
      dashboardFtdate: Date22,
    }

    // console.log(filteredobject);

    if (basicActive === "tab1") {
      setApplyFilterClicked(true);
      setLoading(true)

      // fetchData();
    }
    setPaymentLinkFilterss(true);
    localStorage.setItem("transaction_filter", JSON.stringify(filteredobject))
  }

  // let RoleValue = JSON.parse(localStorage.getItem("loggedUserInfo"))
  //   ? (JSON.parse(localStorage.getItem("loggedUserInfo")).role
  //     ? JSON.parse(localStorage.getItem("loggedUserInfo")).role : "admin") : "staff";

  // const { handlePageAccess } = useAccess();
  // const roleAccess = handlePageAccess("membersmanagement")
  // console.log("roleAccessroleAccess", roleAccess)



  const { handlePageAccess } = useAccess();
  const roleAccess = handlePageAccess("transactions")

  const handleReload = () => {
    window.location.reload();
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      const thElements = document.querySelectorAll('.datatable-header th');

      thElements.forEach((th) => {
        if (th.textContent.trim().includes("Date")) {
          // Hide the icon
          const icon = th.querySelector('i');
          if (icon) {
            icon.style.display = "none";
          }
          // Disable click
          th.style.pointerEvents = "none";
          th.style.cursor = "default";
        }
      });
    }, 1000); // 0.5-second delay

    // Cleanup the timeout
    return () => clearTimeout(timeout);
  }, []);

  function getToken() {
    try {
      const tokenString = localStorage.getItem("transactionId");
      return tokenString;
    } catch (e) {
      console.log("error :::::: " + e);
      return;
    }
  }

  const addMemToLineItems = (newMember) => {

    let memberToAdd = newMember;


    if (typeof newMember === 'object' && '0' in newMember && newMember[0] && typeof newMember[0] === 'object') {

      memberToAdd = newMember[0];
    }

    setMembersList(prevList => {
      const updatedList = [...prevList, memberToAdd];
      return updatedList;
    });
    setOpenAddMember(false);
  };


  const onSubmitUser = () => {
    setSubmitFlag(true);
    setTimeout(() => {
      setSubmitFlag(false);
    }, 100);
  };


  return (
    <>
      <LeftPane isactive="8" />
      <Header />
      {apiError ? <PageError handleReload={handleReload} /> : <div
        className="gym-main rightContent"
      >
        <h3 className="gym-large">Transactions</h3>
        <div className=" ">

          {roleAccess?.totalamount == 1 &&
            <div className="mb-2 d-flex">
              <div className="filters_Count">
                Membership Amount Received: <b>&#8377;{totalTranactions.toLocaleString('en-IN')} </b>
              </div>
              <div className="filters_Count">
                ClassBooking Amount Received: <b>&#8377;{classtransAmount.toLocaleString('en-IN')} </b>
              </div>
              <div className="filters_Count">
                Total Amount Received: <b>&#8377;{(totalTranactions + classtransAmount).toLocaleString('en-IN')} </b>
              </div>
              <div className="filters_Count">
                Total Transactions Count: <b>{totalTranactionsCount} </b>
              </div>

              {/* <div className="filters_Count">
            Total Members Count: <b>{totalMemberCount} </b>
          </div> */}
            </div>}
          <MDBTabs>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab1")}
                active={basicActive === "tab1"}
              >
                Transactions
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => { handleBasicClick("tab4") }} active={basicActive === "tab4"}>
                Class Booking
              </MDBTabsLink>
            </MDBTabsItem>
            {/* {PaymentLinkTrans.length > 0 &&
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => {
                      handleBasicClick("tab3")
                      setMfilter({
                        ...mfilter,
                        tidName: ""
                      })
                    }}
                    active={basicActive === "tab3"}
                  >
                    Payment Links
                  </MDBTabsLink>
                </MDBTabsItem>} */}
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab2")}
                active={basicActive === "tab2"}
              >
                Refund
              </MDBTabsLink>
            </MDBTabsItem>
          </MDBTabs>
        </div>
        <div className="searchFilterToggle">
          {loading && (<h4><Loader /></h4>)}
          {(basicActive === "tab1" || basicActive === "tab3") &&
            <>
              <div className=" d-flex align-items-center flex-wrap w-sm-80 mb-3 mobileResloution" >
                <div className="gym-section order-0">
                  <label className="fw-bold">Search by {basicActive === "tab1" ? "OrderId/Transactions Id/Members" : "Transactions Id"}</label>
                  <div>
                    <input
                      type="text"
                      // ref={searchRef}
                      value={mfilter.tidName}
                      className="form-control select-input  placeholder-active me-3 shadow-1  "
                      placeholder="search here..."
                      onChange={(e) => {

                        setMfilter({
                          ...mfilter,
                          tidName: e.target.value
                        })
                        if (paymentLinkFilterss) setPaymentLinkFilterss(false);
                      }
                      }
                    // setTidName(e.target.value.toLowerCase())}
                    />
                  </div>
                </div>
                <div className="gym-section order-1 ms-3">
                  <label className="fw-bold">Contact</label>
                  <div>
                    <input
                      type="number"
                      // ref={searchRef}
                      value={mfilter.contNme}
                      className="form-control select-input  placeholder-active me-3 shadow-1  "
                      // className="gym-input forminput d-inline-block "
                      placeholder="search here..."
                      onChange={(e) => {
                        setMfilter({
                          ...mfilter,
                          contNme: e.target.value
                        })
                        if (paymentLinkFilterss) setPaymentLinkFilterss(false);
                      }}
                    />
                  </div>
                </div>
                {basicActive === "tab3" &&
                  <div className="gym-section w-100-mobile ms-2">
                    <label className="fw-bold">Status</label>
                    <div>
                      <select
                        className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                        value={paymentLinkFilter}
                        onChange={(e) => {
                          setpaymentLinkFilter(Number(e.target.value))
                          if (paymentLinkFilterss) setPaymentLinkFilterss(false);
                        }}
                      >
                        <option value={2}>All</option>
                        <option value={1}>Success</option>
                        <option value={0}>Pending</option>
                        <option value={3}>Failed</option>
                      </select>
                    </div>
                  </div>}
                <div className="mob-w-100 ms-3 mob-m-0 ">
                  <label className="me-2 fw-bold"> Days </label>
                  <div>
                    <select
                      name="shrs"
                      id="shr"
                      className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                      onChange={(e) => {
                        setDayFilter(e.target.value)
                        if (paymentLinkFilterss) setPaymentLinkFilterss(false);
                      }}
                      value={DayFilter}
                    >
                      <option value="7">All</option>
                      <option value="1">Today</option>
                      <option value="2">Yesterday</option>
                      <option value="3">This Week</option>
                      <option value="4">This Month</option>
                      <option value="5">This Year</option>
                      <option value="6">Custom</option>
                    </select>
                  </div>
                </div>

                {customdate && <div className="gym-section order-2 ms-3">
                  <label className="fw-bold">Date</label>
                  <div className="gym-xlarge z-index_4 gym-larg-pos">
                    <div className="cursor-pointer">
                      <DatePicker
                        dateFormat={"d/M/yyyy"}
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(update) => {
                          setDateRange(update);
                          if (paymentLinkFilterss) setPaymentLinkFilterss(false);
                        }}
                        isClearable={false}
                        customInput={<CalenderInput />}
                      />
                    </div>
                  </div>
                </div>}
                <div className="gym-section order-5 ms-3 " >
                  <div className="mt-2">
                    <button type="submit" className="me-2 btn btn-primary"
                      onClick={(e) => handleApplyAndToggle()}
                    >
                      Apply
                    </button>
                    <button type="submit" className="mt-2 btn btn-secondary"
                      onClick={(e) => handleResetAndToggle()}
                    >
                      Clear
                    </button>
                    {roleAccess?.export == 1 &&
                      <button type="submit" className="ms-2 btnheight btn btn-primary"
                        onClick={(e) => downloaddata(basicActive === "tab1" ? basicData : basicDataP)}
                      >
                        <MDBIcon fas icon="download" className="d-inline me-1" />Export
                      </button>}
                    {roleAccess?.import == 1 &&
                      <button type="submit" className="ms-2 btnheight btn btn-primary" onClick={toggleModal}>
                        <MDBIcon fas icon="file-import" className="d-inline me-1" />Import
                      </button>
                    }
                  </div>
                </div>
              </div>
            </>}
        </div>


        <MDBTabsContent>
          <MDBTabsPane show={basicActive === "tab1"} open={basicActive === "tab1"}>
            <div className="datatable">
              <div className="TransactionsTable sno">
                <table className="table datatable-table">
                  <thead className="datatable-header">
                    <tr>
                      {basicData.columns.map((column, index) => (
                        <th key={index}>{column}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {!basicData.rows && loading ? (<h4> <Loader /></h4>) : basicData.rows.map((row, rowIndex) => (
                      <tr key={rowIndex}  >
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                    {!loading && basicData.rows.length === 0 &&
                      <tr>
                        <td colSpan={9}><p className="d-flex align-items-center justify-content-center"> No Data Found</p></td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              {roleAccess?.pagination == 1 && <div className="datatable-pagination position-relative">
                <label className="pagin-text">  Rows per page </label>
                <div className="ms-2 form-control w-auto">
                  <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))} className="Pagenation-Select">
                    <option value="50">
                      <div className="select-option">
                        50
                      </div>
                    </option>
                    <option value="100">
                      <div className="select-option">
                        100
                      </div>
                    </option>
                    <option value="500">
                      <div className="select-option">
                        500
                      </div>
                    </option>
                    <option value="1000">
                      <div className="select-option">
                        1000
                      </div>
                    </option>
                  </select>
                </div>
                <button onClick={prevPage}
                  disabled={currentPage === 1}
                  className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark">
                  Previous
                </button>
                <div className="d-flex justify-content-between w-120px align-items-center"> Page
                  {/* {currentPage}  */}
                  <input className="form-control w-50px" value={currentPage} onChange={(e) => setCurrentPage(Number(e.target.value))} />
                  of {totalPages}</div>
                <button onClick={nextPage}
                  disabled={currentPage === totalPages}
                  className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark">
                  Next
                </button>
              </div>}
            </div>

          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab2"} show={basicActive === "tab2"}>
            <div className="position-relative mt-2">
              <div className="refundsExportButton">
                {roleAccess?.export == 1 && <button type="submit" className="ms-2 btnheight btn btn-primary"
                  onClick={(e) => downloaddata(basicActive === "tab1" ? basicData : basicDataR)}
                >
                  <MDBIcon fas icon="download" className="d-inline me-1" />Export
                </button>}
              </div>
              <div className="refundsTable search">
                <MDBDatatable className="refundsDataTable "
                  searchLabel="Search by Name/Order Id/Plan/Addon/Contact" search
                  fixedHeader
                  entries={50}
                  maxHeight={filterr ? "65.5vh" : "75vh"}
                  data={basicDataR}
                />
              </div>
            </div>

          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab3"} show={basicActive === "tab3"}>
            <MDBDatatable className="refundsDataTable"
              fixedHeader
              entries={25}
              maxHeight={filterr ? "65.5vh" : "75vh"}
              data={basicDataP}
            />
          </MDBTabsPane>
          <MDBTabsPane open={basicActive == "tab4"} show={basicActive === "tab4"}>
            <ClassTransactions globlefilter={DayFilter} isapplied={applyFilterClicked} globledateRange={dateRange} handleclasstransactioninfo={handleclasstransactioninfo} />
          </MDBTabsPane>
        </MDBTabsContent>


        {isOpen && (
          <Popup
            title={<div className="d-flex align-items-between align-items-center">
              <h5>Transaction Details</h5>
              <MDBBtn className="ms-2" onClick={() => onHandleBillingDetails(transid)}>Edit Billing Details</MDBBtn>
            </div>}
            content={
              <>
                <TransactionDetails
                  oncancel={closePopup}
                  onAssociate={openAUserPop}
                  id={tId}
                  gymid={localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1}
                  token={token}
                  from={"membership"}
                  Rtoken={Rid}
                  transid={transid}
                  filters={filteredobject}
                />
              </>
            }
            handleClose={closePopup}
          />
        )}


        {basicModal && (
          <Popup
            title="Edit Billing Details"
            content={
              <>
                <div>
                  {membersList && membersList.length > 0 && (
                    <div className="mb-3">
                      <label className="fw-bold mb-2">Select Member</label>
                      <ul className="list-unstyled ms-3">
                        {membersList.map((member, index) => {
                          console.log(`Member ${index}:`, member);

                          const fname = member?.fname || '';
                          const lname = member?.lname || '';
                          const memberName = [fname, lname].filter(Boolean).join(' ');
                          const displayName = memberName || "Unnamed Member";
                          const phoneNumber = member?.number || 'No phone';
                          const memberId = member?._id || `temp-id-${index}`;

                          return (
                            <li key={memberId} className="mb-3">
                              <label>
                                <input
                                  type="radio"
                                  name="selectedMember"
                                  value={memberId}
                                  checked={selectedMemberId === memberId}
                                  onChange={() => {
                                    setSelectedMemberId(memberId);
                                    if (fname || lname) {
                                      setParentName(`${fname} ${lname}`.trim());
                                    }
                                    if (member?.number) {
                                      setMobile(member.number);
                                    }
                                    if (member?.email) {
                                      setEmail(member.email);
                                    }
                                  }}
                                  className="me-2"
                                />
                                {displayName}, {phoneNumber}
                              </label>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

                  <MDBBtn onClick={() => setOpenAddMember(!openAddMember)} className="mt-3 mb-3">
                    Add From the System
                  </MDBBtn>

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <label className="fw-bold w-30">Name :</label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      value={parentName}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <label className="fw-bold w-30">Mobile Number :</label>
                    <input
                      className="form-control"
                      type="text"
                      name="mobile"
                      value={mobile}
                      onChange={(e) => handleChangeMobile(e)}
                    />
                  </div>

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <label className="fw-bold w-30">Email:</label>
                    <input
                      className="form-control"
                      type="text"
                      name="email"
                      value={email}
                      onChange={(e) => handleChangeEmail(e)}
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <label className="fw-bold w-30">GSTIN:</label>
                    <input
                      className="form-control"
                      type="text"
                      name="gstin"
                      value={gstobj.gstin}
                      onChange={(e) => handleGstin({ gstin: e.target.value })}
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <label className="fw-bold w-30">Address:</label>
                    {/* <input
                      className="form-control w-40"
                      type="text"
                      name="address"
                      value={gstobj.address}
                    // onChange={(e) => handleChangeEmail(e)}
                    /> */}
                    <textarea className="form-control flex-grow-1" value={gstobj.address}></textarea>
                  </div>

                </div>

                <MDBModalFooter>
                  <MDBBtn onClick={() => basicModalClose()}>Close</MDBBtn>
                  <MDBBtn onClick={() => onSubmitingGurdian(basicModal)}>Submit</MDBBtn>
                </MDBModalFooter>
              </>
            }
            handleClose={() => basicModalClose()}
          />
        )}

        {openAUser && (
          <Popup
            content={
              <>
                <div>
                  <AddUsers id={getToken()} index={1} onsubmit="" submit="" />
                </div>
              </>
            }
            handleClose={closeAddPopup}
          />
        )}
        {deleteTrans && (
          <Popup
            title="Confirm Delete"
            content={
              <>
                <div className="pb-3">
                  <span className="fs-6 pb-3">Are you sure you want to delete this entry?</span>
                </div>
                <MDBModalFooter>
                  <MDBBtn color='secondary' onClick={(e) => setDeleteTrans(null)}>
                    Cancel
                  </MDBBtn>
                  <MDBBtn color="danger" disabled={deleteDisable} onClick={(e) =>
                    roleAccess?.delete == 3 ?
                      otpfield() : transactionDelete(e, deleteTrans)

                  }>Delete</MDBBtn>
                </MDBModalFooter>
              </>
            }
            handleClose={setDeleteTrans}
          />
        )}
      </div>}
      <MDBAlert
        color={Alerttxt.includes("ailed") ? "danger" : (Alerttxt.includes("wait") ? "secondary" : "success")}
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={Alerttxt !== ""}
        onClose={() => setAlerttxt("")}
      >
        {Alerttxt}
      </MDBAlert>
      {paymentLink && (
        <Popup
          title="Resend Payment Link"
          ptype="modal-md"
          from="transactions"
          content={
            <>
              <div>
                <span >To resend the payment link, use the same or a different number.</span>
                <div className="d-flex align-items-center py-4">
                  <label>
                    Send payment link to:
                  </label>
                  <div className="ms-3" >
                    <MDBInput value={number} type="number" onChange={(e) => setNumber(e.target.value)} />
                  </div>
                </div>
                <div class="modal-footer pb-0">
                  <button class="ripple ripple-surface btn btn-secondary" role="button" onClick={() => setPaymentLink(null)}>
                    close
                  </button>
                  <button class="ripple ripple-surface btn btn-primary" role="button" onClick={(e) => { setAlerttxt("Please wait."); setPaymentLink(null); resendPayment(e, paymentLink) }} disabled={number === ""}>
                    Send
                  </button>
                </div>
              </div>
            </>
          }
          handleClose={() => setPaymentLink(null)}
        />
      )}
      <MDBAlert
        color='danger'
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={Error2 != ""}
        onClose={() => setError2("")}
      >
        {Error2}
      </MDBAlert>


      <MDBAlert
        color="success"
        autohide
        position='top-center'
        delay={4000}
        appendToBody
        open={alertText != ""}
        onClose={() => setalertText("")}
      >
        {alertText}
      </MDBAlert>

      <ImportExcelModal
        isOpen={importPopUp}
        toggleModalClose={popUpClose}
        onDownloadSample={handleSampleDownload}
        onImportFile={importTransactionData}
        errorMessage={errorMessage}
      />

      {importError && (
        <MDBToast
          color="danger"
          defaultOpen
          autohide
          position="top-center"
          appendToBody
          width={400}
          delay={5000}
          headerContent={
            <>
              <strong className="me-auto"><h5>Importing Failed!</h5></strong>
            </>
          }
          bodyContent={importError}
        />
      )}


      {openAddMember && (
        <>
          <MDBModal open={openAddMember} onClose={() => setOpenAddMember(false)} tabIndex='-1'>
            <MDBModalDialog size="lg">
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Add Member(s)</MDBModalTitle>
                  <MDBBtn className='btn-close' color='none' onClick={() => {
                    setOpenAddMember(false);
                  }}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>
                  <AddUsers
                    id={getToken()}
                    index={curIndex}
                    onsubmit={onSubmitUser}
                    submit={submitFlag}
                    onAdd={addMemToLineItems}
                  />
                </MDBModalBody>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>

        </>
      )}


      <MDBAlert
        color='danger'
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={gstError != ""}
        onClose={() => setGSTError("")}
      >
        {gstError}
      </MDBAlert>

      {error && <MDBAlert
        color={error.toLowerCase().includes('success') ? 'success' : 'danger'}
        autohide
        position='top-center'
        delay={5000}
        appendToBody
        open={error}
        onClose={() => { setError(null) }}
        style={{ zIndex: 9999 }}
      >
        {error}
      </MDBAlert>
      }
      {centredModal && (<>
        <Popup
          title="Mobile Number Verification"
          ptype="modal-md"
          style=""
          content={
            <div className='text-center'>
              <p>We've sent a One Time Password (OTP) to your mobile number <br />
                <strong>{"+91XXXXXXXXXX"}</strong>
              </p>

              <p className="mb-3">Please enter the 6-digit OTP below to verify your number.</p>

              <div className="d-flex justify-content-center gap-2 mb-3">
                {[...Array(6)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    className="form-control text-center"
                    style={{ width: "40px", fontSize: "1.2rem" }}
                    value={otpDigits[index]}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    ref={(el) => (otpRefs.current[index] = el)}
                  />
                ))}
              </div>

              <p className="text-muted">
                Resend OTP in <strong>{resendTimer > 0 ? `00:${resendTimer.toString().padStart(2, '0')}` :
                  <label onClick={(e) => otpfield(e)} className='button-link fw-600 text-primary fs-14px'>Now</label>}</strong>
              </p>

              <MDBBtn block className="mt-2" onClick={(e) => handleVerifyOTP(e)}>
                Verify OTP
              </MDBBtn>
            </div>
          }
          handleClose={() => setCentredModal(false)}
        />
      </>
      )}
    </>
  );
};

export default Transctions;